import { createCompany } from 'modules/company/actions';
import { backend, domain } from 'modules/data';
import { useDispatch } from 'modules/react-redux';
import { useCallback } from 'react';
import { useInvalidateGetCompanies } from 'shared/data/webApp/v2';

export const useCreateOrganisation = () => {
    const dispatch = useDispatch();

    const invalidateGetCompanies = useInvalidateGetCompanies();

    return useCallback(
        async (integrationType: domain.IntegrationType | null): Promise<backend.CompanyCreatedInfo | null> => {
            let companyCreatedInfo: backend.CompanyCreatedInfo | null = null;

            await dispatch(
                createCompany(integrationType, (companyInfo) => {
                    companyCreatedInfo = companyInfo;

                    void invalidateGetCompanies();
                })
            );

            return companyCreatedInfo;
        },
        [dispatch, invalidateGetCompanies]
    );
};
